module.exports = __webpack_public_path__ + "static/media/6E.c4b896ab.png";